document.querySelectorAll(".tc-tab-menu li").forEach(tab => {

    tab.addEventListener("click", function(){

        document.querySelectorAll(".tc-tab-menu li")
            .forEach(t => t.classList.remove("active"));

        document.querySelectorAll(".tc-pane")
            .forEach(p => p.classList.remove("active"));

        this.classList.add("active");

        document.getElementById(this.dataset.tab)
            .classList.add("active");

    });

});